import { render, staticRenderFns } from "./ManifestKasKecil.vue?vue&type=template&id=354fe86d&scoped=true&"
import script from "./ManifestKasKecil.vue?vue&type=script&lang=js&"
export * from "./ManifestKasKecil.vue?vue&type=script&lang=js&"
import style0 from "./ManifestKasKecil.vue?vue&type=style&index=0&id=354fe86d&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "354fe86d",
  null
  
)

export default component.exports